import { Navigate, Route, Routes } from 'react-router'
import AuthStartPage from 'pages/auth/AuthStartPage'
import {
  LoginUrl,
  SamlLoginUrl,
  SignupUrl,
  SltLoginUrl,
  SSOUrl,
  StartUrl,
  IncorrectAppMotusUrl,
  IncorrectAppEverlanceUrl,
  NewExperienceUrl
} from 'constants/RouteUrls'
import LoginPage from 'pages/auth/LoginPage'
import SamlCallbackPage from 'pages/auth/SamlCallbackPage'
import SltLoginPage from 'pages/auth/SltLoginPage'
import SignupPage from 'pages/auth/SignupPage'
import NotFoundPage from 'routes/NotFoundPage'
import { useSettings } from 'core/hooks/settings/useSettings'
import PurpleStartPage from 'pages/auth/purple/PurpleStartPage'
import PurpleSSOPage from 'pages/auth/purple/PurpleSSOPage'
import PurpleLoginPage from 'pages/auth/purple/PurpleLoginPage'
import { useEffect } from 'react'
import IncorrectAppPage from 'pages/auth/IncorrectAppPage'
import NewExperiencePage from 'pages/auth/purple/NewExperiencePage'

const cleanWildcard = (str: string) => {
  return str.replace('/auth/', '')
}

const AuthRoutes = () => {
  const {
    data: {
      featureFlags: { ENABLE_DRIVER_EXPERIENCE }
    }
  } = useSettings()

  useEffect(() => {
    localStorage.setItem('userType', '')
  }, [])

  return (
    <Routes>
      <Route path="/" element={<Navigate to={StartUrl} replace />} />
      <Route
        path={cleanWildcard(StartUrl)}
        element={
          ENABLE_DRIVER_EXPERIENCE ? <PurpleStartPage /> : <AuthStartPage />
        }
      />
      <Route
        path={cleanWildcard(LoginUrl)}
        element={ENABLE_DRIVER_EXPERIENCE ? <PurpleLoginPage /> : <LoginPage />}
      />

      {/** When on motus flow, SSO url will not exist */}
      {ENABLE_DRIVER_EXPERIENCE && (
        <Route path={cleanWildcard(SSOUrl)} element={<PurpleSSOPage />} />
      )}
      <Route
        path={cleanWildcard(SamlLoginUrl)}
        element={<SamlCallbackPage />}
      />
      <Route path={cleanWildcard(SltLoginUrl)} element={<SltLoginPage />} />
      <Route
        path={`${cleanWildcard(SignupUrl)}/:type?`}
        element={<SignupPage />}
      />
      {ENABLE_DRIVER_EXPERIENCE && (
        <>
          {/* Purple login incorrect app pages */}
          <Route
            path={cleanWildcard(IncorrectAppMotusUrl)}
            element={<IncorrectAppPage company="motus" />}
          />
          <Route
            path={cleanWildcard(IncorrectAppEverlanceUrl)}
            element={<IncorrectAppPage company="everlance" />}
          />
          {/* Purple login redirect to new experience */}
          <Route
            path={cleanWildcard(NewExperienceUrl)}
            element={<NewExperiencePage />}
          />
        </>
      )}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default AuthRoutes
